const cartCookieUpdate = getCookie("cart")
const localCartIDUpdate  = cartCookie ? "gid://shopify/Cart/" + getCookie("cart").replace("%3F","?").replace("%3D","=") : "";
const cartID = localCartIDUpdate

const increaseCartsProducts = async (handleName, SKUvalue) => {
    try {
    
    CartIcon_quantity += 1
    // get variant id of the product on certor store 
    const {variantID:globalVariantID} = await getProductVarient(handleName, SKUvalue)
    // add Product To global Cart
    await addProductToCart_Request(globalVariantID, 1, cartID)
    
    } catch (error) {
        return 
    }
}

const decreaseCartsProducts = async (element, SKUvalue) => {
    try {
        
    CartIcon_quantity -= 1
    const quantity = parseInt(element.nextElementSibling.value) - 1
    // get Cart Line id of the product on certor store 
    const data = await getProductsCart(cartID)
    
    const globalCartLineID = data.data.cart.lines.edges.find((variant) => {
        return variant.node.merchandise.sku === SKUvalue
    })
    // add Product To global Cart
    await updateProductToCart_Request(globalCartLineID.node.id, quantity, cartID)
  

    } catch (error) {
        return
    }
}

const removeCartsProducts = async (SKUvalue) => {

    try {
        
    // get Cart Line id of the product on certor store 
    const data = await getProductsCart(cartID)
    const globalCartLineID = data.data.cart.lines.edges.find((variant) => {
        return variant.node.merchandise.sku === SKUvalue
    })
    CartIcon_quantity -= globalCartLineID.node.quantity

    // add Product To global Cart
    await updateProductToCart_Request(globalCartLineID.node.id, 0, cartID)
 
    } catch (error) {
            
    }
}
